import { Button, Modal } from 'antd';
import { useTranslation } from 'react-i18next';

import { type TDisplayColumnData } from 'components/data/types';
import { type TQueryFilter } from 'components/DataTable/types';
import { ModalActionButtons } from 'components/ui';
import { type AtlasGqlTableView } from 'types/atlas-graphql';

import { Summary } from '../Summary';
import { StyledCollapse } from '../Views.style';

export type ConditionsState = {
  isOpen: boolean;
  tableView?: Partial<AtlasGqlTableView>;
  columnDefs?: TDisplayColumnData[];
};

type ConditionsModalProps = {
  conditionsState: ConditionsState;
  lockedFilters?: TQueryFilter[];
  onClose: () => void;
};

export const ConditionsModal: React.FunctionComponent<ConditionsModalProps> = ({
  conditionsState,
  lockedFilters,
  onClose,
}) => {
  const { t } = useTranslation();
  const { isOpen, tableView, columnDefs } = conditionsState;

  return (
    <Modal
      open={isOpen && !!tableView}
      title={t('table.conditions', 'Conditions')}
      onCancel={onClose}
      destroyOnHidden
      footer={null}
    >
      <StyledCollapse
        defaultActiveKey={['table_conditions']}
        items={[
          {
            key: 'table_conditions',
            label: t('components.tableConditions', 'Table Conditions'),
            children: tableView && columnDefs && (
              <Summary
                tableView={tableView}
                columnDefs={columnDefs}
                lockedFilters={lockedFilters}
              />
            ),
          },
        ]}
      />
      <ModalActionButtons>
        <Button type="primary" onClick={onClose}>
          {t('common.close', 'Close')}
        </Button>
      </ModalActionButtons>
    </Modal>
  );
};
